import { type SipOptions } from '@bv/plugins';
import { getRouter } from '@bv/plugins/router';
import { type Call } from '@bv/stores';
import { ref, type Ref } from 'vue';
import { RouteLocationNormalized } from 'vue-router';

const dialRouteName: string = 'dial';

const hide: Ref<boolean> = ref<boolean>(true);

let routerInstance: ReturnType<typeof getRouter> | null = null;

const getRouterInstance = () => {
  if (!routerInstance) {
    routerInstance = getRouter();
  }
  return routerInstance;
};

export const transfer = (call: Call): void => {
  const router = getRouterInstance();
  if (router) {
    router.replace({
      name: dialRouteName,
      query: {
        transfer: call.id,
      },
    });
  }
};

export const sip: SipOptions | false = {
  connection: 'register',
  widget: {
    props: {
      showExpand: true,
      showTransfer: true,
      hide,
    },
    events: {
      onExpand: () => {
        const router = getRouterInstance();
        if (router) {
          router.push({ name: dialRouteName });
        }
      },
      onTransfer: transfer,
    },
  },
};

export const initSipRouter = () => {
  const router = getRouterInstance();
  if (router) {
    router.beforeEach((to: RouteLocationNormalized): void => {
      hide.value = to.name === dialRouteName;
    });
  }
};
